import { render, staticRenderFns } from "./SignaturesComments.vue?vue&type=template&id=3dea634c"
import script from "./SignaturesComments.vue?vue&type=script&lang=js"
export * from "./SignaturesComments.vue?vue&type=script&lang=js"
import style0 from "./SignaturesComments.vue?vue&type=style&index=0&id=3dea634c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports